﻿import { ApiCaller, FullfilledApiResponse } from 'apis/ApiCaller';

export interface BulbOrganization {
	displayName: string;
	id: string;
	launchURI: string;
	ltiKey: string;
	ltiSecret: string;
}

export interface BulbInfo {
	ConsumerKey: string;
	ConsumerSecret: string;
	LaunchURL: string;
}

export class BulbApi {

    private static apiCaller = new ApiCaller('Bulb');

    public static GetAll(): Promise<BulbOrganization[]> {

	    return this.apiCaller.GET<BulbOrganization[]>('GetAll');

    }

    public static Get(organizationId: string): Promise<BulbOrganization> {

	    return this.apiCaller.GET<BulbOrganization>('Get', { organizationId });

    }

    public static Create(organizationName: string): Promise<BulbOrganization> {

	    return this.apiCaller.POST<BulbOrganization>('Create', { organizationName });

    }

    public static GetGMetrixPartnerInfo(partnerId = 0): Promise<BulbInfo> {

	    return this.apiCaller.GET<BulbInfo>('GetGMetrixPartnerInfo', { partnerId });

    }

    public static SetGMetrixPartnerInfo(externalPlatform: string, key: string, secret: string, launchURL: string, partnerId = 0): Promise<FullfilledApiResponse> {

	    return this.apiCaller.GET<FullfilledApiResponse>('SetGMetrixPartnerInfo', { externalPlatform, key, launchURL, partnerId, secret });

    }

}